export default "__VITE_ASSET__3ac716e7__"